import React, { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import loaderStyles from './dotsLoaderStyles';

interface IDotsLoaderProps {
  className?: string;
  dataTest?: string;
}

const DotsLoader: FunctionComponent<IDotsLoaderProps> = ({ className, dataTest }) => {
  const style = loaderStyles();
  return (
    <Typography component="span" className={className}>
      <span data-test={dataTest}>
        <span className={clsx(style.loaderDot1, style.loaderDot)}>•</span>
        <span className={clsx(style.loaderDot2, style.loaderDot)}>•</span>
        <span className={clsx(style.loaderDot3, style.loaderDot)}>•</span>
      </span>
    </Typography>
  );
};

export default DotsLoader;
